import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../../widgets/tables/Table';
import { NineCellLoading } from 'react-loadingg';
import translateString from '../../utils/Locales';
import getAdminSupportTickets from "../../services/getAdminSupportTickets";

let t = translateString;

export default class Tickets extends React.Component {

  constructor(props){
    super (props)
  
    this.state = {
      newTicket: false,
      isLoading: true,
    };

  }
  
  async load() {

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    this.tickets = await getAdminSupportTickets(username, token);
    this.tickets.forEach((ticket) => {
      if (ticket.solved == 0) {
        ticket.solved = t('in_lavorazione');
      } else {
        ticket.solved = t('conclusa');
      }
    });
    this.tickets = this.tickets.filter((ticket) => ticket.id_thread === null);

    this.setState({ isLoading: false });
  }

  async componentDidMount(){
      await this.load();
  }

  render () {

    var headCells = [
      { id: 'creation_date', numeric: true, disablePadding: false, label: t('data') },
      { id: 'db_name', numeric: true, disablePadding: false, label: t('cliente') },
      { id: 'subject', numeric: false, disablePadding: true, label: t('oggetto') },
      { id: 'solved', numeric: true, disablePadding: false, label: t('stato') },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];

    this.searchCols = ['subject', 'message'];

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    return (
      <div>
          <PageTitle title={t('assistenza')} />

          <Table headCells={headCells} searchCols={this.searchCols} calendar={false} pdf={false} excel={false} mail={false} phone={false} rows={this.tickets}
      
              onEventClick={(row) => {
                  window.location.href = '/admin#/admin/ticketDetails?ticket=' + row;
              }}
          />
      </div>
    );
  }
}

